import i18n from 'i18next'

import { Currency } from 'modules/purchase/constants'

const PRICE_FRACTION_DIGITS = 2
const LATIN_DIGITS_NUMBERING_SYSTEM = 'latn'
const WHOLE_PRICE_CURRENCIES: string[] = [Currency.NGN, Currency.IDR]
const LOCALE_BY_CURRENCY: Record<string, string> = {
  [Currency.SGD]: 'en-SG',
  [Currency.NGN]: 'en-NG',
  [Currency.CAD]: 'en-CA',
  [Currency.ILS]: 'he-IL',
  [Currency.MYR]: 'ms-MY',
  [Currency.IDR]: 'id-ID',
  [Currency.CHF]: 'de-CH',
  [Currency.QAR]: 'ar-QA',
  [Currency.ZAR]: 'en-ZA',
  [Currency.MAD]: 'en-US',
  [Currency.AUD]: 'en-AU',
  [Currency.BDT]: 'en-US',
  [Currency.INR]: 'en-US',
}

const getPriceFormat = (currency: string): Intl.NumberFormat => {
  const fractionDigits = WHOLE_PRICE_CURRENCIES.includes(currency)
    ? 0
    : PRICE_FRACTION_DIGITS

  return new Intl.NumberFormat(
    new Intl.Locale(LOCALE_BY_CURRENCY[currency] ?? i18n.language, {
      numberingSystem: LATIN_DIGITS_NUMBERING_SYSTEM,
    }).toString(),
    {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    },
  )
}

export const getLocalizedPrice = (price: number, currency: string): string =>
  getPriceFormat(currency).format(price)

export const getLocalizedPriceParts = (
  price: number,
  currency: string,
): { wholePart: string; decimalPart: string } => {
  const parts = getPriceFormat(currency).formatToParts(price)

  return {
    wholePart: parts
      .filter(({ type }) => type === 'integer' || type === 'group')
      .map(({ value }) => value)
      .join(''),
    decimalPart: parts.find(({ type }) => type === 'fraction')?.value ?? '',
  }
}
